import { PropertiesPanel } from "@components/panels/PropertiesPanel"

interface ServiceStreamingDonePanelProps {
    content: any
}
export function ServiceStreamingDonePanel({ content }: Readonly<ServiceStreamingDonePanelProps>) {
    return <pre className="h-full text-left overflow-auto whitespace-pre-wrap break-all">{typeof content === "object" && content !== null ? <PropertiesPanel value={content} className="!px-0" /> : content}</pre>
}
